import { useChartTooltipStore } from '@modules/charts/components/ChartTooltipWrapper/hooks';
import { getChartLabelIdOrName } from '@modules/charts/utils';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { FieldNames } from 'v2/core/entities/fields';
import { shallow } from 'zustand/shallow';
import { MergeWithAllSeletedReasonSVGIcon } from './MergeWithAllSeletedReasonSVGIcon';

export const MergeWithAllSelectedReasonAction = () => {
  const visibleDataPoints = useQuantifyStore(
    ({ query: { visibleDataPoints = [] } }) => visibleDataPoints,
  );

  const tableRows = useQuantifyStore(
    ({ query: { compareQuery }, reportData }) =>
      compareQuery
        ? reportData.compare.tableRows
        : reportData.quantify.tableRows,
  );

  const { payload, setData, fieldName, shouldShowMergeReason } =
    useChartTooltipStore(
      ({ payload, setData, fieldName, shouldShowMergeReason }) => ({
        payload,
        setData,
        fieldName,
        shouldShowMergeReason,
      }),
      shallow,
    );

  const openDrawer = () => {
    if (!tableRows?.length) {
      return;
    }

    const visibleDataPointIDs = new Set(
      visibleDataPoints?.map((dataPoint) => getChartLabelIdOrName(dataPoint)),
    );

    const suggestedLabelsToMerge = tableRows
      .filter(
        (tableRow) =>
          visibleDataPointIDs.has(tableRow.id) && !tableRow.isInvisible,
      )
      .map((tableRow) => {
        return {
          id: tableRow?.id || '',
          label: tableRow?.label || '',
          category: tableRow?.category,
        };
      });

    if (
      !suggestedLabelsToMerge.some((suggested) => suggested.id === payload?.id)
    ) {
      suggestedLabelsToMerge.push({
        id: payload?.id || '',
        label: payload?.label || '',
        category: payload?.category,
      });
    }

    const activeMergeSuggestion = payload?.id
      ? {
          category: payload?.category,
          id: payload?.id || '',
          suggestedName: payload?.label || '',
          suggestedLabelsToMerge,
        }
      : null;

    setData({
      activeMergeSuggestion,
      shouldShowConfirmMergeDrawer: true,
    });
  };

  if (!shouldShowMergeReason || fieldName !== FieldNames.Reason) {
    return null;
  }

  return (
    <MenuItem onClick={openDrawer} disabled={visibleDataPoints?.length < 1}>
      <ListItemIcon>
        <MergeWithAllSeletedReasonSVGIcon
          sx={{
            color: 'text.disabled',
          }}
        />
      </ListItemIcon>
      <ListItemText primary="Merge with all selected Reasons" />
    </MenuItem>
  );
};
